<template>
  <div>
    <Filtro @clientesRuraisFiltrados="atualizarFiltro" :redirectToCadastroEdicao="redirectToCadastroEdicao" />
    <div>
      <div class="text-center" v-if="loadingTabela === true">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>
      <div class="card" v-if="loadingTabela === false">
        <div class="card-body">
          <Grid :filtro="filtro" :items="items" @editarItem="editarItem" @clientesRuraisFiltrados="atualizarFiltro" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from "@/components/astec/filtro";
import Grid from "@/components/astec/gridClienteRural";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Filtro,
    Grid
  },
  data() {
    return {
      filtro: {},
      items: [],
      currentPage: 1,
      itemsPerPage: 10,
      loadingTabela: null,
    };
  },

  created() {
    this.$tools.fecharMenu();
  },
  methods: {
    redirectToCadastroEdicao() {
      this.$store.commit("CLIENTE_RURAL_ASTEC", "");
      this.$router.push({ path: "clienteRural/cadastroEdicao/" });
    },
    async atualizarFiltro(novoFiltro, callback) {
      await this.buscarItens(novoFiltro);
      if (typeof callback === 'function'){
        callback();
      }
    },
    async editarItem(item) {
      this.$store.commit("CLIENTE_RURAL_ASTEC", item);
      this.$router.push({ path: "clienteRural/cadastroEdicao/" });
    },
    async buscarItens(filtro) {
      this.loadingTabela = true;
      try {
        const response = await this.$http.post("/api/astec/getClienteRuralLista", filtro);
        this.items = response.data;
      } catch (err) {
        this.$tools.alerta(err.response?.data?.message || "Erro desconhecido", "error");
      } finally {

        this.loadingTabela = false;
      }
    }
  },
};
</script>

<style>
.sortable-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sort-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5px;
}
</style>
